import { CustomError } from '@/store/types';
import api from './api';

interface ForgotPasswordDto {
  usernameOrEmail: string;
  clientId?: string;
  recaptchaResponse: string;
}

interface ResetPasswordDto {
  username: string;
  token: string;
  newPassword: string;
  clientId?: string;
}

export default {
  async login(usernameOrEmail: string, password: string): Promise<any> {
    return api.post(
      `/auth/login`,
      {
        username: usernameOrEmail,
        password,
      },
      { withCredentials: true },
    );
  },

  async resetPassword({ username, token, newPassword, clientId }: ResetPasswordDto): Promise<any> {
    try {
      return await api.post(`/auth/reset-password`, {
        username,
        token,
        newPassword,
        clientId,
      });
    } catch (e) {
      const error = e as CustomError;
      if (error.error === 'INVALID_TOKEN') {
        error.message = 'This link has expired.';
      }

      throw error;
    }
  },

  async forgotPassword({
    usernameOrEmail,
    clientId,
    recaptchaResponse,
  }: ForgotPasswordDto): Promise<any> {
    try {
      return await api.post('/auth/forgot-password', {
        usernameOrEmail,
        clientId,
        recaptchaResponse,
      });
    } catch (e) {
      const error = e as CustomError;
      if (error.error === 'NoRegisteredEmailException') {
        return { email: null };
      }

      throw e;
    }
  },
};
